import { faEdit, faX, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import { userManagementMessages } from 'src/features/userManagement/utils';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/utils/messages';

import type { Membership } from 'src/features/userManagement/types';

interface CellEditMembershipProps<TData, TValue> extends CellContext<TData, TValue> {
    editMembershipCallback: (member: TData) => void;
    membershipStatusCallback: (member: TData) => void;
    userStatusAction: 'activate' | 'deactivate';
}
function CellUsersTableActions({
    editMembershipCallback,
    membershipStatusCallback,
    userStatusAction,
    row,
}: CellEditMembershipProps<Membership, unknown>) {
    const { formatMessage } = useIntl();

    const tooltip = userStatusAction === 'deactivate' ? generalMessages.deactivate : generalMessages.activate;

    return (
        <div className="ml-auto flex gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button onClick={() => editMembershipCallback(row.original)} size="icon" variant="link">
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        {`${formatMessage(generalMessages.edit)} ${formatMessage(userManagementMessages.user).toLocaleLowerCase()}`}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button onClick={() => membershipStatusCallback(row.original)} size="icon" variant="link">
                            <FontAwesomeIcon icon={userStatusAction === 'deactivate' ? faX : faCheck} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        {`${formatMessage(tooltip)} ${formatMessage(userManagementMessages.user).toLocaleLowerCase()}`}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}

export { CellUsersTableActions };
